import { c as _c } from "react/compiler-runtime";
import { IcoDotsHorizontal16 } from '@onefootprint/icons';
import type { DashboardSecretApiKey } from '@onefootprint/request-types/dashboard';
import { Dropdown, IconButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
type RowMenuProps = {
  apiKey: DashboardSecretApiKey;
  onToggleReveal: () => void;
  onToggleStatus: () => void;
  size?: 'compact' | 'default';
};
const RowMenu = t0 => {
  const $ = _c(29);
  const {
    apiKey,
    onToggleReveal,
    onToggleStatus,
    size: t1
  } = t0;
  const size = t1 === undefined ? "compact" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "table"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("api-keys", t2);
  const isEnabled = apiKey.status === "enabled";
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp2);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== size || $[6] !== t4) {
    t5 = <Dropdown.Trigger asChild={true}><div><IconButton aria-label={t4} size={size} variant="ghost" icon={IcoDotsHorizontal16} /></div></Dropdown.Trigger>;
    $[5] = size;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <PermissionGate scopeKind="api_keys" fallbackText={t3}>{t5}</PermissionGate>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== apiKey.key || $[12] !== t) {
    t7 = apiKey.key ? t(_temp3) : t(_temp4);
    $[11] = apiKey.key;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onToggleReveal || $[15] !== t7) {
    t8 = <Dropdown.Item onSelect={onToggleReveal}>{t7}</Dropdown.Item>;
    $[14] = onToggleReveal;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isEnabled || $[18] !== t) {
    t9 = isEnabled ? t(_temp5) : t(_temp6);
    $[17] = isEnabled;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onToggleStatus || $[21] !== t9) {
    t10 = <Dropdown.Item onSelect={onToggleStatus}>{t9}</Dropdown.Item>;
    $[20] = onToggleStatus;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8) {
    t11 = <Dropdown.Portal><Dropdown.Content align="end"><Dropdown.Group>{t8}{t10}</Dropdown.Group></Dropdown.Content></Dropdown.Portal>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t6) {
    t12 = <Dropdown.Root>{t6}{t11}</Dropdown.Root>;
    $[26] = t11;
    $[27] = t6;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default RowMenu;
function _temp($) {
  return $.manage.notAllowed;
}
function _temp2($_0) {
  return $_0.manage.ariaLabel;
}
function _temp3($_1) {
  return $_1.manage.reveal.hide;
}
function _temp4($_2) {
  return $_2.manage.reveal.show;
}
function _temp5($_3) {
  return $_3.manage.status.disable;
}
function _temp6($_4) {
  return $_4.manage.status.enable;
}